// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3861O","spin":"Spinner_spin__3c6kM","container":"Spinner_container__2rCyH"};